import type {
  ExperienceApiFilter,
  ListItemAvatar,
  ReviewApiFilter,
  ReviewsListItemExperience,
} from '@/shared/api/experience';

export interface Link {
  slug?: string;
  title?: string;
}

export enum ListSortItemValue {
  RANK = 'rank',
  PUBLISHED_AT = 'published_at',
  RATING = 'rating',
}

export interface SeoCategory {
  id: number;
  experiencesApiFilters: ExperienceApiFilter;
  reviewsApiFilters: ReviewApiFilter;
  countryRu: string;
  countrySlug: string;
  categoryTitle: string;
}

export type ReviewsListItemSnack = {
  avatar: ListItemAvatar;
  createdAt: string;
  createdOn: string;
  createdOnDt: string;
  experience: ReviewsListItemExperience;
  guideReply: string;
  id: number;
  isShowingProcessingPhotos: boolean;
  name: string;
  photos: Array<string>;
  rating: number;
  text: string;
  travelerLevel: number;
};

export interface TagWithActive {
  category_slug: string;
  tag_name: string;
  tours_count: number;
  isActive?: boolean;
}
